import React, { Component } from 'react'
import Card from '../card'
import CardContainer from '../card-container/cardContainer'
import CardHolder from '../../card-holder/cardHolder'
import CardTitle from '../../card-title/card-title'
import { getCall, baseUrl } from '../../../../../helpers/api'
import queryString from 'query-string'

class TypeCardsExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            types: []
        }
    }

    async componentDidMount() {
        const values = queryString.parse(this.props.location.search)
        if (!Object.prototype.hasOwnProperty.call(values, "pn")) {
            values.pn = "Geniş Yapraklı"
        }
        const types = await getCall("/leafShape/getByParent", {values})
        await this.setState({ types: types.data })
    }

    render() {
        return (
            <CardContainer>
                <CardTitle title="Yaprak Şeklini Seçin" />
                <CardHolder>
                    {this.state.types.map((t, index) => (
                        <Card key={index} history={this.props.history} image={baseUrl + t.image} typeText={t.typeName} />
                    ))}
                </CardHolder>
            </CardContainer>
        )
    }
}

export default TypeCardsExample
